import { motion } from 'framer-motion';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useThemeScoreColor } from '../../hooks';

interface CircularProgressScoreProps {
  score: number; // 0–100
  size?: number; // default 100
  strokeWidth?: number; // default 8
}

export const CircularProgressScore = ({
  score,
  size = 100,
  strokeWidth = 8,
}: CircularProgressScoreProps) => {
  const scoreColor = useThemeScoreColor(score);

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;

  return (
    <Box position="relative" width={size} height={size}>
      {/* Background Circle */}
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={scoreColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference}
          strokeLinecap="round"
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 3, ease: 'easeOut' }}
        />
      </svg>

      {/* Centered Score */}
      <Box
        position="absolute"
        top={0}
        left={0}
        width={size}
        height={size}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h6" fontWeight={600}>
          {score}%
        </Typography>
      </Box>
    </Box>
  );
};
